import { ElementUnderMousePointer } from '@ukpostbox/helpers';
import { SetSelectedMailItemDetails } from './Helpers';
import { DisableFoldersById, ResetFolderStates } from './CustomFolders';
import { MailItemDragEndType, MailItemDragType } from '../Types/SharedFunctions/DragAndDropTypes';

const MailItemDrag = (props: MailItemDragType) => {
	const target: HTMLElement | null = props.event.target as HTMLElement;
	if (!target) return;

	const targetId = target.getAttribute('data-item-id');

	if (
		!!targetId &&
		target &&
		props.event.dataTransfer &&
		target.matches('.mailbox-item') &&
		props.event.button === 0
	) {
		if (!props.selectedItems.includes(targetId)) {
			props.toggleSelectedCallback(targetId as string);
		}

		SetSelectedMailItemDetails(props.event, target.className, props.mailboxInfo);

		if (props.mailboxInfo.customFolderId) {
			DisableFoldersById(props.mailboxInfo.customFolderId.toString());
		}

		props.draggingActiveCallback(true);
	}
};

const MailItemDragEnd = (props: MailItemDragEndType) => {
	props.event.preventDefault();

	if (props.event.clientX && props.event.clientY) {
		const target: Element | null = ElementUnderMousePointer(
			props.event.clientX,
			props.event.clientY,
		) as HTMLElement;

		if (
			target &&
			target.matches(
				'.folder-entry:not(.folder-dropper-not-allowed), .custom-folder-list-entry:not(.folder-dropper-not-allowed)',
			)
		) {
			props.moveSelectedItemsCallback(parseInt(target.getAttribute('data-folder-id') as string, 10));
		}
	}

	ResetFolderStates();
	props.draggingActiveCallback(false);
};

export { MailItemDrag, MailItemDragEnd };
